import { ResourceTypeLink } from "@evergis/api";
import { Tooltip } from "@evergis/ui";
import React, { FC, useMemo } from "react";
import { ResourcesTooltip } from "./ResourcesTooltip";

type ResourceReferencesTooltipProps = {
  references: string[];
  otherReferences?: string[];
  resourceType?: ResourceTypeLink;
};

export const LayerReferencesTooltip: FC<ResourceReferencesTooltipProps> = ({
  references,
  otherReferences,
  resourceType = ResourceTypeLink.Layer,
}) => {
  const tooltipContent = useMemo(
    () => <ResourcesTooltip resources={references} otherResources={otherReferences} resourceType={resourceType} />,
    [references, otherReferences, resourceType],
  );

  return (
    <Tooltip content={tooltipContent} placement="right" arrow delay={0.5}>
      {ref => <abbr ref={ref}>{references.length + (otherReferences ? otherReferences?.length : 0)}</abbr>}
    </Tooltip>
  );
};
